import Store from 'redux/store';
import {
  APPEND_NEW_STORE_RATING,
  APPEND_NEW_STORE_RATING_FAIL,
  APPEND_NEW_STORE_RATING_SUCCESS,
} from 'redux/Reducers/Average/AverageReducer';
import { premmiar } from '../clients';

/* eslint-disable */
export const AppendStoreAverage = async (User, finallyCallback = () => {}, { identification, userName, participantId, catalogId }) => {
  Store.dispatch({
    type: APPEND_NEW_STORE_RATING,
    payload: {
      store: identification,
    },
  });
  premmiar(User).get(`/api/RatingAverage/Average?identification=${identification}&type=2`).then((response) => {
    Store.dispatch({
      type: APPEND_NEW_STORE_RATING_SUCCESS,
      payload: {
        store: identification,
        data: response.data,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: APPEND_NEW_STORE_RATING_FAIL,
      payload: {
        store: identification,
        error: e,
      },
    });
  })
    .finally(() => {
      finallyCallback();
    });
};
